import { Campaign, CampaignGroupFilter } from 'src/types';
import { CampaignIdToGroupIds } from './aggregate';

export const buildCampaignIdToGroupIds = (
  campaigns: Array<Campaign>,
  groups: Array<CampaignGroupFilter>,
): CampaignIdToGroupIds => {
  const nameToId = new Map<string, string>();
  campaigns.forEach((c) => nameToId.set(c.name, c.id));

  const map: CampaignIdToGroupIds = new Map();
  groups.forEach((g) => {
    g.campaignNames.forEach((name) => {
      const cid = nameToId.get(name);
      if (!cid) return;
      if (!map.has(cid)) map.set(cid, new Set());
      map.get(cid)!.add(g.id);
    });
  });
  return map;
};
